/***
 * 致终于来到这里的勇敢的人：
 * 你是被上帝选中的人，是英勇的、不敌辛苦的、不眠不休的来修改我们这最棘手的代码的编程骑士。
 * 你，我们的救世主，人中之龙，我要对你说：永远不要放弃，永远不要对自己失望，永远不要逃走，辜负了自己，
 * 永远不要哭啼，永远不要说再见，永远不要说谎来伤害自己。
 */
import Vue from 'vue'
import App from './App.vue'

import router from './router/index'
import store from './store'
import Element from 'element-ui'
// import '@/element.config.ts'
import '@/style/iconfont.js'

Vue.use(Element)
Vue.prototype.$ELEMENT = { size: 'mini' }

Vue.config.productionTip = true

Vue.prototype.$_has = function (power) {
  const judgeObject = (target) => Object.prototype.toString.call(target)
  let url = store.getters.power
  let resourcePermission = url.map(val => val.method_and_url)
  let permission = true
  const type = judgeObject(power)
  // if (resourcePermission.length === 0) {
  //   Vue.prototype.$msgbox.alert('账户已冻结,请联系管理员', '提示')
  // }
  if (type === '[object Array]') {
    let permission = true
    for (let i in power) {
      let has = resourcePermission.findIndex((ele) => {
        return ele === power[i]
      })
      if (has === -1) {
        permission = false
      }
    }
    return permission
  } else if (type === '[object Object]') {
    let permission = false
    for (let i in power) {
      let has = resourcePermission.findIndex((val) => {
        return val === power[i]
      })
      if (has !== -1) {
        permission = true
      }
    }
    return permission
  }
}

// router.beforeEach((to, from, next) => {
//   // console.log('to, from, next: ', to, from, next)
//   next()
//   /* must call `next` */
// })

Vue.directive('has', {
  bind: function (el, bind) {
    if (!Vue.prototype.$_has(bind.value || bind.expression)) {
      el.parentNode.removeChild(el)
    }
  }
})
/* eslint-disable no-new */
let app = new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
})

export default app



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/main.ts